<template>
    <div class="cst-survey-thanks">
        <p>{{ $t('thanksTextFinish') }}</p>
        <button class="cst-survey-btn-finish" @click="finish">{{ $t('thanksBtnFinish') }}</button>
        <p>{{ $t('thanksTextContinue') }}</p>
        <button class="cst-survey-btn-next" @click="next">{{ $t('thanksBtnContinue') }}</button>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    export default {
      props: ['content'],
      methods: {
        finish: function () {
          // this.$store.dispatch('finishSurvey').then(() => {
          this.$store.dispatch('gotoNamedCard', 'finished')
          // })
        },
        next: function () {
          eventHub.$emit('card-next')
        },
        holidayCheck: function () {
          this.$store.dispatch('gotoNamedCard', 'holiday-check')
        }
      },
      created: function () {
        eventHub.$emit('set-title', this.$t('thanksTitle'))
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-btn-finish {
        background-color: @tertiary-button-color;
        .cst-survey-btn;
    }

    .cst-survey-btn-next {
        background-color: @main-button-color;
        .cst-survey-btn;
    }

    .cst-survey-thanks p {
        text-align: center;
        font-size: 130%;
    }
    .cst-survey-thanks button {
      margin: 0 auto;
      display: block;
    }

</style>




// WEBPACK FOOTER //
// src/components/CardThanks.vue